module.exports = __webpack_public_path__ + "media/images/home-quote-4e263dc8e9c3f434660de9eec666ea8a.jpg";